/** Payload / UI field keys for Reserve Equipments & Add-ons (aligned with sample payload). */
export const RESERVE_EQUIPMENTS_ADDON_FIELD_ADD_ON_NAME = "Add-On Name";
export const RESERVE_EQUIPMENTS_ADDON_FIELD_ADD_ON_TYPE = "Add-On Type";
export const RESERVE_EQUIPMENTS_ADDON_FIELD_ADD_ON_DESCRIPTION =
  "Add-On Description";
export const RESERVE_EQUIPMENTS_ADDON_FIELD_ADD_ON_CATEGORY = "Add-On Category";
export const RESERVE_EQUIPMENTS_ADDON_FIELD_ADD_ON_SUB_CATEGORY =
  "Add-On Sub-Category";
export const RESERVE_EQUIPMENTS_ADDON_FIELD_QTY_IN_STOCK = "Qty in Stock";
export const RESERVE_EQUIPMENTS_ADDON_FIELD_PRICING_TYPE = "Pricing Type";

/** Pricing Type dropdown values (Reserve Equipments/Add-ons). */
export const RESERVE_EQUIPMENTS_ADDON_PRICING_TYPE_OPTIONS = [
  "By duration",
  "By session",
] as const;

export const RESERVE_EQUIPMENTS_ADDON_FIELD_PRICE = "Price";
export const RESERVE_EQUIPMENTS_ADDON_FIELD_ADDITIONAL_RATES_PER_MINS =
  "Additional Rates per mins";

export const RESERVE_EQUIPMENTS_ADDON_NAME_FIELD =
  RESERVE_EQUIPMENTS_ADDON_FIELD_ADD_ON_NAME;
export const RESERVE_EQUIPMENTS_ADDON_TYPE_FIELD =
  RESERVE_EQUIPMENTS_ADDON_FIELD_ADD_ON_TYPE;
export const RESERVE_EQUIPMENTS_ADDON_DESCRIPTION_FIELD =
  RESERVE_EQUIPMENTS_ADDON_FIELD_ADD_ON_DESCRIPTION;

export const RESERVE_EQUIPMENTS_ADDON_LIST_CODE_KEY = "Code";
export const RESERVE_EQUIPMENTS_ADDON_LIST_NAME_KEY = "Name";
